import { Button, HTMLTable, Icon, Popover, Classes } from '@blueprintjs/core';
import moment from 'moment-timezone';
import React from 'react';
import { DATE_FORMAT, SHORT_TIME_FORMAT_24 } from '../../../utils/Constants';
import { arrowsIconTable, flexRow, htmlHeaderStyle, htmlTableStyle, openTripsTablePopover, tdPadding, verticalAlignMiddle } from '../../styles';
import MenuOpenTrip from '../menuComponents/menuOpenTrip';
import DialogNonParComplete from '../modalComponents/dialogNonParComplete';
import OverlayConfirmProvider from '../modalComponents/overlayConfirmProvider';
import { showDialysisIndicator, showVipIndicator, showWcIndicator } from './../../../utils/bizCommon';
import OverlayWillcall from './../modalComponents/overlayWillcall';
import OverlayCancelTrip from './../modalComponents/overlayCancelTrip';


export default class OpenTripsTable extends React.Component {

  state = {
    isOverlayConfirmProvider: false,
    isDialogConfirmProvider: false,
    isDialogRemoveProvider: false,
    isDialogSendSms: false,
    isOverlayConfirmTripCancellation: false,
    sortBy: 'DueTime',
    sortOrder: 'ASC',
  }

  handleConfirmedMenuClick = (event) => {
    if (this.props.selectedTrip !== null) {
      const id = event.currentTarget.id;
      this.setState({
        [id]: true,
      })
    }
  }

  handleSorting = (headerColumn) => {
    this.setState({
      sortBy: headerColumn,
      sortOrder: this.state.sortOrder === 'ASC' ? 'DESC' : 'ASC'
    }, () => this.props.refreshTrips(this.state.sortBy, this.state.sortOrder));
  }

  onModalClosed = (id) => {
    this.setState({
      [id]: false,
    })
    this.props.refreshTrips(this.state.sortBy, this.state.sortOrder)
  }


  render() {
    const headers = [
      { name: 'Due Date', column: 'DueTime' },
      { name: 'Due Time', column: 'DueTime' },
      { name: 'First Name', column: 'PassengerFirstName' },
      { name: 'Last Name', column: 'PassengerLastName' },
      { name: 'Serv. Level', column: 'ServiceLevelName' },
      { name: 'Client', column: 'ClientName' },
      { name: 'Pickup Address', column: 'PuAddressLine1' },
      { name: 'City', column: 'PuCity' },
      { name: 'State', column: 'PuState' },
      { name: '# PAX', column: 'PassengerCount' },
      { name: '# WC', column: 'PassengerWcCount' },
      { name: 'Miles', column: 'TripMiles' },
    ];


    return (
      <>
        <HTMLTable bordered condensed interactive style={htmlTableStyle}>
          <thead>
            <tr>
              {headers.map(header => {
                return (
                  <th key={header.name} style={htmlHeaderStyle(this.props.themeName === Classes.DARK)} onClick={() => this.handleSorting(header.column)}>
                    {header.name}
                    <Icon style={arrowsIconTable} icon={'double-caret-vertical'} iconSize={13} />
                  </th>
                );
              })}
              <th style={htmlHeaderStyle(this.props.themeName === Classes.DARK)}></th>
            </tr>
          </thead>

          <tbody id='optentrips-table'>
            {this.props.trips.map(trip => (
              <tr key={trip.tripNumber} id={trip.tripNumber} onClick={(e) => this.props.setSelectedTrip(e)} style={verticalAlignMiddle}>
                <td style={tdPadding}>{moment.tz(trip.dueDateTime, trip.pickupTimeZone).format(`${DATE_FORMAT}`)}</td>
                <td style={tdPadding}>
                  <div style={flexRow}>
                    {moment.tz(trip.dueDateTime, trip.pickupTimeZone).format(`${SHORT_TIME_FORMAT_24} z`)}&nbsp;
                    {showVipIndicator(trip.isVip)}
                  </div>
                </td>

                <td style={tdPadding}>
                  <div style={flexRow}>
                    {trip.passengerFirstName}
                    &nbsp;{showDialysisIndicator(trip.customFields)}
                  </div>
                </td>

                <td style={tdPadding}>{trip.passengerLastName}</td>
                <td style={tdPadding}>
                  <div style={flexRow}>
                    {trip.serviceLevel}&nbsp;
                    {showWcIndicator(trip.wheelchairType)}
                  </div>
                </td>
                <td style={tdPadding}>{trip.clientName}</td>
                <td style={tdPadding}>{trip.pickupAddressLine1}</td>
                <td style={tdPadding}>{trip.pickupCity}</td>
                <td style={tdPadding}>{trip.pickupState}</td>
                <td style={tdPadding}>{trip.passengerCount}</td>
                <td style={tdPadding}>{trip.passengerWcCount}</td>
                <td style={tdPadding}>{Number(trip.tripMiles).toFixed(1)}</td>
                <td style={tdPadding}>
                  <Popover style={openTripsTablePopover} content={
                    <MenuOpenTrip
                      handleConfirmedMenuClick={this.handleConfirmedMenuClick}
                      selectedCheckbox={this.props.selectedCheckbox}
                      trip={this.props.selectedTrip}
                    />
                  }>
                    <Button small icon="menu-open" />
                  </Popover>
                </td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
        {this.state.isOverlayConfirmProvider && (
          <OverlayConfirmProvider
            id={'isOverlayConfirmProvider'}
            trip={this.props.selectedTrip}
            isSelectNewDriver={false}
            onModalClosed={this.onModalClosed}
          />
        )
        }
        {this.state.isDialogNonParComplete && (
          <DialogNonParComplete id={'isDialogNonParComplete'} trip={this.props.selectedTrip} onModalClosed={this.onModalClosed} />
        )
        }

        {this.state.isOverlayWillcall && (
          <OverlayWillcall
            id={'isOverlayWillcall'}
            trip={this.props.selectedTrip}
            onModalClosed={this.onModalClosed}
            message={`Are you sure you want to activate the willcall Trip ${this.props.selectedTrip.tripNumber}?`} />
        )
        }
        {this.state.isOverlayConfirmTripCancellation && (
          <OverlayCancelTrip
            id={'isOverlayConfirmTripCancellation'}
            tripNumber={this.props.selectedTrip?.tripNumber}
            message={`Are you sure you want to cancel Trip ${this.props.selectedTrip?.tripNumber}?`}
            onModalClosed={this.onModalClosed}
            themeName={this.props.themeName}
          />
        )
        }
      </>
    )
  }
}
